import TableElement from 'components/organisms/players-to-exchange/table-elements/table-element';
import React from 'react';
import TeamLogo from 'components/molecules/team-logo';
import PlayerInterface from 'interfaces/players-data-interfaces/player-interface';
import BuilderInterface from 'components/organisms/players-to-exchange/available-players/builder-interface';
import LineupInterface from 'interfaces/lineups-data-interfaces/lineup-interface';
import BasePlayerBuilder from 'components/organisms/players-to-exchange/available-players/base-player-builder';
import {getValuesAsPercent} from 'helpers/common-helper';

export default class TiersBuilder extends BasePlayerBuilder implements BuilderInterface {
    getTableHead(): Array<TableElement> {
        const elements = {
            'td-pos': 'Pos',
            'td-name': 'Name',
            'td-tier': 'Tier',
            'td-team': 'Team',
            'td-opponent': 'Opponent',
            'td-fpts': 'Fpts',
            'td-min': 'MIN',
            'td-ppm': 'PPM',
            'td-dvp': 'DvP%',
            'td-rating': 'Rating',
            'td-ceiling': 'Ceiling Proj',
            '': '',
        };

        return this.buildRow(elements);
    }

    getTableBody(
        player: PlayerInterface,
        substitutablePlayer: PlayerInterface,
        lineup: LineupInterface,
        salaryCapExceeded: boolean,
    ): Array<TableElement> {
        const elements = {
            'td-pos': player.positionName,
            'td-name': player.name,
            'td-tier': player.rosterPosition,
            'td-team': <TeamLogo teamName={player.team} />,
            'td-opponent': <TeamLogo teamName={player.opponent} />,
            'td-fpts': player.getUserPointsByMode(),
            'td-min': player.getPropValue('expected_minutes'),
            'td-ppm': player.getPropValue('points_per_minute'),
            'td-dvp': getValuesAsPercent(player.dvp),
            'td-rating': player.grades,
            'td-ceiling': player.getCeilingPointsByMode(),
            '': this.getSwapButton(salaryCapExceeded, substitutablePlayer, player, lineup),
        };

        return this.buildRow(elements);
    }
}
